import { render } from "./Ofertas.vue?vue&type=template&id=3e0a812e&scoped=true"
import script from "./Ofertas.vue?vue&type=script&lang=js"
export * from "./Ofertas.vue?vue&type=script&lang=js"

import "./Ofertas.vue?vue&type=style&index=0&id=3e0a812e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0a812e"]])

export default __exports__